// extracted by mini-css-extract-plugin
export default {"search":"Search_search__PQsNp","box":"Search_box__qN8OV","focusedSearch":"Search_focusedSearch__CiJtq"};